export default __webpack_public_path__ + "static/download-image-3-784df7a61aecde7deed7020472e701b6.png";